module.exports = __webpack_public_path__ + "static/scale-model-of-travel-incorporated-in-fargo-north-dakota-402e704739647dcff6c8f13923ce5ef6.png";